import { Link, useParams } from "react-router-dom";
import Error from "../../Components/Error";
import Loading from "../../Components/Loading";
import { useGetProductQuery } from "../../Redux/Apis/shopApi";
import Product from "../Components/Product";
// import RelatedItems from "../Components/RelatedProduct";
import Breadcrumb from "../Components/Breadcrumb";
// import Cart from "../Components/Cart";
import { useState } from "react";
import Cart from "../Components/Cart";


export default function Single(){
    const params = useParams()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
      } = useGetProductQuery(params.id)

      const [showCart, setShowCart] = useState(false);

      if(isLoading)
        return <Loading/>
    
      else if(isError)
        return <Error data={error}/>
    
      else if(isSuccess)
        return(
            <>
            {data && data.Shop.status === "ACTIVE" ? <div className='bootstrap-iso border-top border-0' style={{boxShadow: "inset 0 7px 9px -7px rgba(171, 116, 66,0.4)"}}>
                {data.images && <Breadcrumb name={data.name} image={data.images} cat={data.ProductCategory} product={data.name}/>}
                <Product data={data} showCart={setShowCart}/>
            </div> :
            <div className='bootstrap-iso text-center '>
                <div className="alert alert-info my-5 py-5" role="alert">
                  <p>
                  چنین محصولی موجود نیست یا فروشگاه غیر فعال است
                  </p>
                    <Link to="/" className='btn btn-primary'>بازگشت به سایت</Link> 
                </div>
            </div>
            }
            {/* shopping cart  */}
            {showCart && <Cart onClose={() => setShowCart(false)}/> }
            </>
        )
}